



























import {Component, Vue, Prop} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';

@Component({
  components: {
    IconButton,
  },
})
export default class Card extends Vue {
  // Заголовок
  @Prop({required: false, default: ''})
  title!: string;

  // Подзаголовок
  @Prop({required: false, default: ''})
  subtitle!: string;

  // Показатель режима редактирования
  @Prop({required: false, default: false})
  edit!: boolean;

  // Действия при удалении
  onRemove() {
    this.$emit('remove');
  }
}
